/**
 * Product Success Dialog - Post-creation confirmation
 */

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { CheckCircle2 } from "lucide-react";

interface ProductSuccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  productName: string;
  onCreateNew: () => void;
  onBackToList: () => void;
}

export function ProductSuccessDialog({
  open,
  onOpenChange,
  productName,
  onCreateNew,
  onBackToList,
}: ProductSuccessDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="h-6 w-6 text-primary" />
            <AlertDialogTitle>Produto cadastrado com sucesso!</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="space-y-2 pt-4">
            <div>
              <strong>Produto:</strong> {productName}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onBackToList}>
            Voltar à lista
          </AlertDialogCancel>
          <AlertDialogAction onClick={onCreateNew}>
            Cadastrar novo produto
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
